import type { Lang } from "./ajuda";

export const traducoesTopico: Record<Lang, {
  heroTitle: string;
  searchPlaceholder: string;
  searchAriaLabel: string;
  principaisAssuntos: string;
  explorarTopicos: string;
  atalhos: string;
  precisaMaisAjuda: string;
  entreContato: string;
  idioma: string;
  termosUso: string;
  privacidade: string;
  preferenciasCookies: string;
  informacoesCorporativas: string;
  // Principais assuntos (links)
  principaisLabels: { label: string; href: string }[];
  // Categorias explorar (só títulos; sub-itens podem ficar em pt por simplicidade)
  categorias: { id: string; title: string }[];
  atalhosLabels: { label: string; href: string }[];
}> = {
  pt: {
    heroTitle: "Como podemos ajudar?",
    searchPlaceholder: "Digite uma pergunta, assunto ou problema",
    searchAriaLabel: "Buscar na central de ajuda",
    principaisAssuntos: "Principais assuntos:",
    explorarTopicos: "Explorar tópicos",
    atalhos: "Atalhos",
    precisaMaisAjuda: "Precisa de mais ajuda?",
    entreContato: "Entre em contato",
    idioma: "Idioma",
    termosUso: "Termos de uso",
    privacidade: "Privacidade",
    preferenciasCookies: "Preferências de cookies",
    informacoesCorporativas: "Informações corporativas",
    principaisLabels: [
      { label: "Como assinar", href: "/topicos/introducao" },
      { label: "Planos e preços", href: "/topicos/planos" },
      { label: "Não consigo acessar a conta", href: "/topicos/conta" },
      { label: "Controle parental", href: "/topicos/controle-parental" },
    ],
    categorias: [
      { id: "conta-faturamento", title: "Conta e faturamento" },
      { id: "corrigir-problema", title: "Corrigir um problema" },
      { id: "reproduzir-assistir", title: "Reproduzir e assistir" },
      { id: "introducao", title: "Introdução" },
    ],
    atalhosLabels: [
      { label: "Redefinição de senha", href: "/topicos/redefinir-senha" },
      { label: "Atualizar email", href: "/topicos/atualizar-email" },
      { label: "Obtenha ajuda para acessar a conta", href: "/topicos/acesso-conta" },
      { label: "Atualizar forma de pagamento", href: "/topicos/atualizar-pagamento" },
      { label: "Solicitação de séries ou filmes", href: "/topicos/solicitar-conteudo" },
    ],
  },
  en: {
    heroTitle: "How can we help?",
    searchPlaceholder: "Type a question, topic or issue",
    searchAriaLabel: "Search help center",
    principaisAssuntos: "Main topics:",
    explorarTopicos: "Explore topics",
    atalhos: "Shortcuts",
    precisaMaisAjuda: "Need more help?",
    entreContato: "Contact us",
    idioma: "Language",
    termosUso: "Terms of use",
    privacidade: "Privacy",
    preferenciasCookies: "Cookie preferences",
    informacoesCorporativas: "Corporate information",
    principaisLabels: [
      { label: "How to subscribe", href: "/topicos/introducao" },
      { label: "Plans and pricing", href: "/topicos/planos" },
      { label: "I can't access my account", href: "/topicos/conta" },
      { label: "Parental control", href: "/topicos/controle-parental" },
    ],
    categorias: [
      { id: "conta-faturamento", title: "Account and billing" },
      { id: "corrigir-problema", title: "Fix an issue" },
      { id: "reproduzir-assistir", title: "Stream and watch" },
      { id: "introducao", title: "Introduction" },
    ],
    atalhosLabels: [
      { label: "Password reset", href: "/topicos/redefinir-senha" },
      { label: "Update email", href: "/topicos/atualizar-email" },
      { label: "Get help accessing account", href: "/topicos/acesso-conta" },
      { label: "Update payment method", href: "/topicos/atualizar-pagamento" },
      { label: "Request series or movies", href: "/topicos/solicitar-conteudo" },
    ],
  },
  es: {
    heroTitle: "¿Cómo podemos ayudarte?",
    searchPlaceholder: "Escribe una pregunta, tema o problema",
    searchAriaLabel: "Buscar en el centro de ayuda",
    principaisAssuntos: "Temas principales:",
    explorarTopicos: "Explorar temas",
    atalhos: "Atajos",
    precisaMaisAjuda: "¿Necesitas más ayuda?",
    entreContato: "Contáctanos",
    idioma: "Idioma",
    termosUso: "Términos de uso",
    privacidade: "Privacidad",
    preferenciasCookies: "Preferencias de cookies",
    informacoesCorporativas: "Información corporativa",
    principaisLabels: [
      { label: "Cómo suscribirme", href: "/topicos/introducao" },
      { label: "Planes y precios", href: "/topicos/planos" },
      { label: "No puedo acceder a mi cuenta", href: "/topicos/conta" },
      { label: "Control parental", href: "/topicos/controle-parental" },
    ],
    categorias: [
      { id: "conta-faturamento", title: "Cuenta y facturación" },
      { id: "corrigir-problema", title: "Solucionar un problema" },
      { id: "reproduzir-assistir", title: "Reproducir y ver" },
      { id: "introducao", title: "Introducción" },
    ],
    atalhosLabels: [
      { label: "Restablecer contraseña", href: "/topicos/redefinir-senha" },
      { label: "Actualizar correo", href: "/topicos/atualizar-email" },
      { label: "Ayuda para acceder a la cuenta", href: "/topicos/acesso-conta" },
      { label: "Actualizar forma de pago", href: "/topicos/atualizar-pagamento" },
      { label: "Solicitar series o películas", href: "/topicos/solicitar-conteudo" },
    ],
  },
};
